/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type ModerateCardContainerLocal = {
    readonly moderationQueueSort: COMMENT_SORT | null;
    readonly " $refType": "ModerateCardContainerLocal";
};
export type ModerateCardContainerLocal$data = ModerateCardContainerLocal;
export type ModerateCardContainerLocal$key = {
    readonly " $data"?: ModerateCardContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateCardContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateCardContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderationQueueSort",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '4455bfc94f47b5d1025b7f04534d818c';
export default node;
